import React from 'react'

import * as S from './styled'

export const DropdownDivider = () => {
  return <S.Divider />
}
